// ==================== HELPER FUNCTIONS ====================

import { PDFDocument } from "pdf-lib";

export const getBase64FromUrl = async (url: string): Promise<string> => {
  const response = await fetch(url, {
    mode: 'cors',
    headers: { 'Accept': 'image/*' },
  });
  if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const patientNameWithTitle=(gender: string, fullName: string)=>{
   const xy= gender?.toLowerCase() || '';
  if(xy==='male') return `Mr. ${fullName}`;
  if(xy==='female') return `Ms. ${fullName}`;
  console.log('triggred', fullName)
  
  return fullName;
}

export const getPatientPronouns = (gender: string): Record<string, string> => {
  const g = gender.toLowerCase();
  if (g === 'male')   return { he_she: 'he',   his_her: 'his',   him_her: 'him'  };
  if (g === 'female') return { he_she: 'she',  his_her: 'her',   him_her: 'her'  };
  return               { he_she: 'they', his_her: 'their', him_her: 'them' };
};


export const convertGender = (choice: string): 'male' | 'female' | 'other' | '' => {
  const lower = choice?.toLowerCase() || '';
  if (lower.includes('male') && !lower.includes('female')) return 'male';
  if (lower.includes('female')) return 'female';
  if (lower.includes('other')) return 'other';
  return '';
};

// export const formatPrescriptionContent = (data: PrescriptionFormData): string => {
//   const lines: string[] = [];
  
//   lines.push('Complaints of-', data.complaintsOf, '');
//   lines.push(`History of symptoms- ${data.historyOfSymptoms}`);
//   lines.push(`Past history of similar symptoms- ${data.pastHistoryOfSimilarSymptoms}`);
//   lines.push(`Concurrent illnesses- ${data.concurrentIllnesses}`);
  
//   const substanceText = data.substanceIntake === 'Yes' && data.substanceIntakeDetails
//     ? `${data.substanceIntake} (${data.substanceIntakeDetails})`
//     : data.substanceIntake;
//   lines.push(`Any substance intake- ${substanceText}`);
  
//   lines.push(`Any significant past history of disease- ${data.significantPastHistory}`);
  
//   const surgeryText = data.historyOfSurgery === 'Yes' && data.surgeryDetails
//     ? `${data.historyOfSurgery} (${data.surgeryDetails})`
//     : data.historyOfSurgery;
//   lines.push(`Any history of surgery- ${surgeryText}`);
  
//   const travelText = data.historyOfTravel === 'Yes' && data.travelDetails
//     ? `${data.historyOfTravel} (${data.travelDetails})`
//     : data.historyOfTravel;
//   lines.push(`History of travel- ${travelText}`);
  
//   const familyText = data.relevantFamilyHistory === 'Yes' && data.familyHistoryDetails
//     ? `${data.relevantFamilyHistory} (${data.familyHistoryDetails})`
//     : data.relevantFamilyHistory;
//   lines.push(`Any relevant family history- ${familyText}`);
  
//   lines.push(`Intensity of symptoms- ${data.intensityOfSymptoms}`);
  
//   const selfMedText = data.selfMedicationHomeRemedies === 'Yes' && data.selfMedicationDetails
//     ? `${data.selfMedicationHomeRemedies} (${data.selfMedicationDetails})`
//     : data.selfMedicationHomeRemedies;
//   lines.push(`Self-medication / home remedies- ${selfMedText}`);
  
//   lines.push('', 'Special notes by Registered Medical Practitioner-', data.specialNotesByRMP, '');
//   lines.push('Advice by Registered Medical Practitioner-', data.adviceByRMP, '');
//   lines.push(`Full Diagnosis of the illness- ${data.fullDiagnosis}`, '');
  
//   const validRxLines = data.rxLines.filter(line => line.trim());
//   if (validRxLines.length > 0) {
//     lines.push('RX');
//     validRxLines.forEach((line, index) => lines.push(`${index + 1}. ${line}`));
//   }
  
//   return lines.join('\n');
// };

// ==================== PDF OPERATIONS ====================

export const fetchPdfFromPath = async (path: string): Promise<ArrayBuffer> => {
  try {
    const response = await fetch(path);
    if (!response.ok) {
      throw new Error(`Failed to fetch PDF: ${response.statusText}`);
    }
    return await response.arrayBuffer();
  } catch (error) {
    console.error('Error fetching PDF:', path, error);
    throw error;
  }
};

export const mergeBasePdfs = async (
  basePdf1: any,
  basePdf2: any
): Promise<ArrayBuffer> => {
  try {
    const toUint8Array = async (pdf: string | ArrayBuffer | Uint8Array): Promise<Uint8Array> => {
      if (typeof pdf === 'string') {
        if (pdf.startsWith('data:')) {
          const base64Data = pdf.split(',')[1];
          return Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
        } else if (pdf.startsWith('/') || pdf.startsWith('http')) {
          const arrayBuffer = await fetchPdfFromPath(pdf);
          return new Uint8Array(arrayBuffer);
        } else {
          return Uint8Array.from(atob(pdf), c => c.charCodeAt(0));
        }
      } else if (pdf instanceof ArrayBuffer) {
        return new Uint8Array(pdf);
      } else if (pdf instanceof Uint8Array) {
        return pdf;
      }
      throw new Error('Unsupported basePdf type');
    };

    const [pdf1Data, pdf2Data] = await Promise.all([
      toUint8Array(basePdf1),
      toUint8Array(basePdf2)
    ]);
    
    const mergedPdf = await PDFDocument.create();
    const pdf1Doc = await PDFDocument.load(pdf1Data);
    const pdf2Doc = await PDFDocument.load(pdf2Data);
    
    const pages1 = await mergedPdf.copyPages(pdf1Doc, pdf1Doc.getPageIndices());
    pages1.forEach(page => mergedPdf.addPage(page));
    
    const pages2 = await mergedPdf.copyPages(pdf2Doc, pdf2Doc.getPageIndices());
    pages2.forEach(page => mergedPdf.addPage(page));
    
    const pdfBytes = await mergedPdf.save();
    return pdfBytes.buffer as ArrayBuffer;
  } catch (error) {
    console.error('Error merging base PDFs:', error);
    throw new Error(`Failed to merge template backgrounds: ${(error as Error).message}`);
  }
};

export const formatDate = (dateStr: string): string => {
  if (!dateStr) return '';

  // Already in dd/mm/yyyy — return as-is
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) return dateStr;

  // Standard yyyy-mm-dd from <input type="date">
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  }

  // Fallback: parse anything JS's Date can understand
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr; // unparseable — return raw

  const day   = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year  = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatTime = (timeStr: string): string => {
  if (!timeStr) return '';
  const [hourStr, minute] = timeStr.split(':');
  if (!hourStr || !minute) return timeStr;
  const hour = parseInt(hourStr, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minute} ${ampm}`;
};
